import { translate } from "shared/languages";
import PATHS from "shared/constants/paths";
import PackageComparisonContent from "./PackageComparisonContent";

const MembershipComparisonPage = () => (
  <PackageComparisonContent
    type="membership"
    title={translate("analyticsPage.membership.report_compare")}
    backTo={PATHS.ANALYTICS}
  />
);

export default MembershipComparisonPage;
